<template>
  <div class="d-flex justify-content-around">
    <vue-chartist
      class="height-200"
      type="Pie"
      :data="labelsPieData"
      :options="labelsPieOptions"
    />
    <div class="map-legend">
      <div class="legend-scale d-flex">
        <ul class="legend-labels row">
          <div class="col-xl-6">
            <li><span style="background: #41b883"></span> FASENRA</li>
            <li><span style="background: #4b7cf3"></span> TEZPIRE</li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import VueChartist from 'v-chartist'
export default {
  name: 'PieChartLegends',
  components: {
    'vue-chartist': VueChartist,
  },
  props: ['fasenra', 'tezpire'],
  watch: {
    tagrisso() {
      this.labelsPieData.series[0].value = this.fasenra
      this.labelsPieData.series[1].value = this.tezpire
    },
  },
  data() {
    return {
      labelsPieData: {
        series: [
          {
            value: this.fasenra,
          },
          {
            value: this.tezpire,
          },
        ],
      },
      labelsPieOptions: {
        ignoreEmptyValues: true,
        // labelInterpolationFnc(value) {
        //   return value[0]
        // },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
    }
  },
}
</script>

<style scoped>
.class1 {
  color: #4b7cf3;
}
.map-legend .legend-title {
  text-align: left;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 100%;
  font-family: 'Mukta';
}
.map-legend .legend-scale ul {
  margin: 50px;
  padding: 0;
  list-style: none;
}
.map-legend .legend-scale ul li {
  display: block;
  width: 150px;
  margin-bottom: 6px;
  text-align: left;
  font-size: 100%;
  list-style: none;
}
.map-legend ul.legend-labels li span {
  display: inline;
  float: left;
  height: 15px;
  width: 15px;
  margin-right: 15px;
}
.map-legend .legend-source {
  font-size: 70%;
  color: #999;
  clear: both;
}
.map-legend a {
  color: #777;
}
</style>
